<template>
  <div>
    <div class="font-sans h-screen bg-gray-200">
      <div
        class="flex flex-wrap w-full justify-center md:justify-between items-center py-3 bg-white shadow-lg"
      >
        <div class="flex ml-0 md:ml-6 cursor-pointer pr-4 items-center">
          <img alt="school logo" class="h-10 w-10" src="../../images/gciosa.png" />
          <span
            class="ml-1 text-xl text-white text-blue-900 font-semibold invisible md:visible"
          >GCIOSA</span>
        </div>

        <ul
          class="md:flex sm:block mt-6 md:mt-0 ml-6 md:ml-0 overflow-x-auto mr-0 md:mr-10 font-semibold pt-0 md:pt-2"
        >
          <li
            class="mb-2 px-4 py-1 bg-white border-red-900 hover:bg-red-900 rounded-lg text-red-900 hover:text-white"
            style="border-width: 1px"
          >
            <a @click="logout" class="text-sm">Logout</a>
          </li>
        </ul>
      </div>

      <div v-if="loading" class="h-screen w-full">
          <div class="flex h-screen items-center">
                <vue-loaders name="ball-spin-fade-loader" color="#2a4365" class="flex m-auto my-4" scale="1"></vue-loaders>
          </div>
      
    </div>

      <div v-else
        class="grid grid-cols-1 md:grid-cols-2 gap-4 mx-2 md:mx-auto py-4 md:w-1/2 mt-10 bg-gray-200"

      >
        <div class="px-2">
          <div
            @click="goToAnnouncement"
            class="flex flex-col py-6 w-full mb-2 md:mb-4 md:px-4 items-center justify-center overflow-hidden rounded-lg shadow-md bg-white h-48 md:h-56 md:mx-8 cursor-pointer hover:bg-gray-300"
          >

          <div class="flex-row">
            <MessageCircleIcon size="2.5x" class="mx-auto text-gray-600"></MessageCircleIcon>
            <p class="mb-6 text-sm tracking-wider capitalize font-medium text-gray-900">Announcements</p>
          </div>
            

            <span class="relative inline-block px-4 py-2 font-semibold text-blue-900 leading-tight">
              <span aria-hidden class="absolute inset-0 bg-blue-200 opacity-50 rounded-full"></span>
              <span class="relative text-xl">{{dashboard.announcements}}</span>
            </span>
          </div>
        </div>

        <div class="px-2">
          <div
            @click="goToGallery"
            class="flex flex-col py-6 w-full mb-2 md:mb-4 md:px-4 items-center justify-center overflow-hidden rounded-lg shadow-md bg-white h-48 md:h-56 md:mx-8 cursor-pointer hover:bg-gray-300"
          >
            <div class="flex-row">
            <ImageIcon size="2.5x" class="mx-auto text-gray-600"></ImageIcon>
            <p class="mb-6 text-sm tracking-wider capitalize font-medium text-gray-900">Photo Albums</p>
          </div>
            <span class="relative inline-block px-4 py-2 font-semibold text-blue-900 leading-tight">
              <span aria-hidden class="absolute inset-0 bg-blue-200 opacity-50 rounded-full"></span>
              <span class="relative text-xl">{{dashboard.photos}}</span>
            </span>
          </div>
        </div>

        <div class="px-2">
          <div
            @click="goToUser"
            class="flex flex-col py-6 w-full mb-2 md:mb-4 md:px-4 items-center justify-center overflow-hidden rounded-lg shadow-md bg-white h-48 md:h-56 md:mx-8 cursor-pointer hover:bg-gray-300"
          >
            <div class="flex-row">
            <UsersIcon size="2.5x" class="mx-auto text-gray-600"></UsersIcon>
            <p class="mb-6 text-sm tracking-wider capitalize font-medium text-gray-900">Users</p>
          </div>
            <span class="relative inline-block px-4 py-2 font-semibold text-blue-900 leading-tight">
              <span aria-hidden class="absolute inset-0 bg-blue-200 opacity-50 rounded-full"></span>
              <span class="relative text-xl">{{dashboard.users}}</span>
            </span>
          </div>
        </div>

        <div class="px-2">
          <div
            @click="gotoAdmins"
            class="flex flex-col py-6 w-full mb-2 md:mb-4 md:px-4 items-center justify-center overflow-hidden rounded-lg shadow-md bg-white h-48 md:h-56 md:mx-8 cursor-pointer hover:bg-gray-300"
          >
            <div class="flex-row">
            <UserCheckIcon size="2.5x" class="mx-auto text-gray-600"></UserCheckIcon>
            <p class="mb-6 text-sm tracking-wider capitalize font-medium text-gray-900">Admins</p>
          </div>
            <span class="relative inline-block px-4 py-2 font-semibold text-blue-900 leading-tight">
              <span aria-hidden class="absolute inset-0 bg-blue-200 opacity-50 rounded-full"></span>
              <span class="relative text-xl">{{dashboard.admins}}</span>
            </span>
          </div>
        </div>
      </div>

      <!--        <announcement></announcement>-->

      <!--        <photo-gallery></photo-gallery>-->
    </div>
  </div>
</template>

<script>
// import Announcement from "./Announcement";
// import PhotoGallery from "./PhotoGallery";
import Axios from "axios";
import {UsersIcon, ImageIcon, UserCheckIcon, MessageCircleIcon} from 'vue-feather-icons';

export default {
  name: "AdminDashboard",
  components: {UsersIcon, ImageIcon, UserCheckIcon, MessageCircleIcon},
  data: function() {
    return {
      dashboard: {},
      loading: null
    };
  },
  methods: {
    getDashboardDetails() {
      this.loading = true;
      let token = localStorage.getItem("token");
      // console.log(token);
      if (token !== null) {
        Axios.get("/api/dashboard", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }).then(response => {
          this.loading = false;
          // console.log(response.data);
          if (response.data.status === true) {
            this.dashboard = response.data.data;
          } else {
            this.$router.push("/");
            this.$swal({
              toast: true,
              showConfirmButton: false,
              timer: 1500,
              title: response.data.message,
              position: "center"
            });
          }
        });
      } else {
        this.$router.push("/");
        this.$swal({
          toast: true,
          showConfirmButton: false,
          timer: 1500,
          title: "please login",
          position: "center"
        });
      }
    },

    goToAnnouncement: function() {
      this.$router.push("/admin/announcement");
    },
    goToGallery: function() {
      this.$router.push("/admin/gallery");
    },
    goToUser: function() {
      this.$router.push("/admin/users");
    },
    gotoAdmins: function() {
      this.$router.push("/admin/admins");
    },
    logout: function() {
      localStorage.clear();
      this.$router.push("/");
    }
  },
  mounted() {
    this.getDashboardDetails();
  }
};
</script>

<style scoped>
</style>
